import short from "short-uuid";

const translator = short();
export const uuid = translator.new;
